import {useEffect, useState} from 'react'


export const getInitialTheme = () => {
  if (typeof window !== "undefined" && window.localStorage) {
    const storedPrefs = window.localStorage.getItem("theme");
    if (typeof storedPrefs === "string") {
      return storedPrefs;
    }
    const userMedia = window.matchMedia("(prefers-color-scheme: dark)");
    if (userMedia.matches) {
      return "light";
    }
  }
  return "light";
};


export default function useDarkMode() {
    const [theme, setTheme] = useState(getInitialTheme)
    const colorTheme = theme === "light" ? "dark" : "light"
    

    useEffect(() => {
        const root = window.document.documentElement
        root.classList.remove(colorTheme)
        root.classList.add(theme)
        localStorage.setItem("theme", theme)
    }, [theme, colorTheme])


    return [colorTheme, setTheme]
}


